let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bx5md")).then(() => parcelRequire('8NKu1'));